import { createStyles } from '@mantine/core';
import TYPOGRAPHY_FLAT from '@styles/fonts/fontsizes/typography-flat';

export const useStyles = createStyles(() => {
  return {
    item: {
      border: 'unset',
    },
    control: {
      padding: '8px 8px',
      borderRadius: 4,
      '&:hover': {
        backgroundColor: 'var(--beam-color-blue-b50)',
      },
    },
    label: {
      ...TYPOGRAPHY_FLAT.h400,
    },
    content: {
      padding: 0,
      paddingTop: 16,
    },
    chevron: {
      marginLeft: 0,
      '&[data-rotate]': {
        transform: 'rotate(-90deg)',
      },
    },
    root: {
      overflow: 'auto',
    },
  };
});
